//  Врач – Медсестра – Учитель – Воспитатель – Бухгалтер – Водитель – Повар – Слесарь-ремонтник – Электрогазосварщик – Электромонтер

export const chapterList = 
  {
    id: 1,
    name: 'РАЗДЕЛ 1',
    descr: `Общерегиональные профессии, востребованные на&nbsp;всех арктических территориях`,
    list: [
      {
        id: 5,
        text: 'Врач',
        branches: [
          {
            id: 1,
            title: 'ДЕЯТЕЛЬНОСТЬ В ОБЛАСТИ ЗДРАВООХРАНЕНИЯ И СОЦИАЛЬНЫХ УСЛУГ',
            li: [
              `ГОБУЗ «Мурманский областной клинический многопрофильный центр» (Мурманская область)`,
              `ГБУЗ АО «Архангельская областная клиническая больница» (Архангельская область)`,
              `ГОБУЗ «Мурманская областная клиническая больница имени П. А. Баяндина» (Мурманская область)`,
              `ГБУЗ ЯНАО «Надымская центральная районная больница» (ЯНАО)`,
            ],
          }
        ],
        qualities: [
          {
            id: 1,
            body: `Знание специфики заболеваемости и течения заболеваний в Арктическом регионе и ее учет в профессиональной деятельности`,
          },{
            id: 2,
            body: `Учет «синдрома полярного напряжения» как фактора, влияющего на здоровье, в том числе на состояние психики при лечении пациентов`,
          },{
            id: 3,
            body: `Учет особенностей культуры коренных народов, проживающих в Арктике`,
          },{
            id: 4,
            body: `Владение навыками работы с технологиями телемедицины при диагностике, консультировании, лечении и реабилитации пациентов`,
          },{
            id: 5,
            body: `Широкие врачебные компетенции, выходящие за пределы одной специализации`,
          },{
            id: 6,
            body: `Компетенции по организации работы передвижных медицинских отрядов (ПМО) для проведения медосмотров и оказания действенной помощи (госпитализация, обследование, питание, лечение) в удаленных и труднодоступных районах, в том числе в местах проживания и ведения хозяйственной деятельности коренными народами`,
          }
        ],
      },{
        id: 3,
        text: 'Медицинская сестра',
        branches: [
          {
            id: 1,
            title: 'ДЕЯТЕЛЬНОСТЬ В ОБЛАСТИ ЗДРАВООХРАНЕНИЯ И СОЦИАЛЬНЫХ УСЛУГ ',
            li: [
              `ГБУЗ ЯНАО «Ноябрьская центральная городская больница» (ЯНАО)`,
              `ГБУЗ ЯНАО «Новоуренгойская центральная городская больница» (ЯНАО)`,
              `ГБУЗ АО «Архангельская областная клиническая больница» (Архангельская область)`,
              `ГОБУЗ «Мурманский областной клинический многопрофильный центр» (Мурманская область)`,
            ],
          }
        ],
        qualities: [
          {
            id: 1,
            body: `Знание специфики заболеваемости и течения заболеваний в Арктическом регионе`,
          },{
            id: 2,
            body: `Учет «синдрома полярного напряжения» как фактора, влияющего на здоровье, в том числе состояние психики при осуществлении медицинского ухода за пациентами и работе с их родственниками`,
          },{
            id: 3,
            body: `Знание особенностей культуры коренных народов, проживающих на территории АЗ РФ`,
          },{
            id: 4,
            body: `Владение навыками работы с технологиями телемедицины в пределах своей компетенции`,
          },{
            id: 5,
            body: `Оказание доврачебной медико-санитарной помощи с учетом арктической специфики`,
          },{
            id: 6,
            body: `Профессиональное взаимодействие с персоналом отделения, медицинскими службами, пациентами `,
          }
        ],
      },{
        id: 4,
        text: 'Учитель',
        branches: [
          {
            id: 1,
            title: 'ОБРАЗОВАНИЕ',
            li: [
              `МБОУ СШ № 23 имени А.С. Пушкина (Архангельская область)`,
              `МБОУ СОШ № 1 имени Аркадия Ваганова (Мурманская область)`,
              `МОУ «Гимназия г. Надыма» (ЯНАО)`,
              `МБОУ «Гуманитарная гимназия № 8» (Архангельская область)`,
            ],
          }
        ],
        qualities: [
          {
            id: 1,
            body: `Учет повышенной нагрузки на организм, связанной с природно-климатическими условиями Арктики, в том числе отслеживание неустойчивости психики и лабильности настроения, мониторинг рисков заболеваний в раннем возрасте`,
          },{
            id: 2,
            body: `Знание основ традиционной культуры коренных народов, проживающих на территории АЗ РФ, и их учет при ведении педагогической деятельности`,
          },{
            id: 3,
            body: `Совмещение двух и более педагогических специальностей в условиях малокомплектных школ и дефицита педагогических кадров`,
          },{
            id: 4,
            body: `Навыки работы в формате дистанционного обучения, применение новых образовательных технологий`,
          },{
            id: 5,
            body: `Проектирование индивидуальных образовательных маршрутов саморазвития, индивидуальная оценка динамики развития ребенка`,
          },{
            id: 6,
            body: `Разработка нестандартного дизайна занятий`,
          },{
            id: 7,
            body: `Психологическая поддержка детей, взаимодействие с родителями`,
          }
        ],
      },{
        id: 6,
        text: 'Воспитатель',
        branches: [
          {
            id: 1,
            title: 'ОБРАЗОВАНИЕ ',
            li: [
              `МБДОУ МО «Город Архангельск» «Центр развития ребенка - детский сад №173 «Подснежник» (Архангельская область)`,
              `МБДОУ «Светлячок» МО город Губкинский (ЯНАО)`,
              `МБДОУ г. Мурманска №125 (Мурманская область)`,
              `МБДОУ «Детский сад №68 «ЛАДУШКИ» (ГО Норильск) (Красноярский край)`,
            ],
          },{
            id: 2,
            title: 'ДОБЫЧА ПОЛЕЗНЫХ ИСКОПАЕМЫХ ',
            li: [
              `ООО «Газпром добыча Уренгой» (ЯНАО)`,
            ],
          }
        ],
        qualities: [
          {
            id: 1,
            body: `Оптимизация процесса обучения с учетом утомляемости детей, разгрузки в период короткого светового дня, повышенной нагрузки на организм, связанной с природно-климатическими условиями Арктики`,
          },{
            id: 2,
            body: `Мониторинг рисков заболеваний детей в раннем возрасте`,
          },{
            id: 3,
            body: `Умение управлять своим поведением, контролировать свои эмоции, способность к рефлексии, стрессоустойчивость`,
          },{
            id: 4,
            body: `Игровая компетенция`,
          },{
            id: 5,
            body: `Разработка нестандартного подхода к занятиям, учитывающего арктическую специфику`,
          },{
            id: 6,
            body: `Эмпатия к детям`,
          },{
            id: 7,
            body: `Психологическая поддержка детей, взаимодействие с родителями`,
          }
        ],
      },{
        id: 7,
        text: 'Бухгалтер',
        branches: [
          {
            id: 1,
            title: 'ДОБЫЧА ПОЛЕЗНЫХ ИСКОПАЕМЫХ ',
            li: [
              `ООО «Газпром добыча Уренгой» (ЯНАО)`,
              `ООО «Газпром добыча Надым» (ЯНАО)`,
            ],
          },{
            id: 2,
            title: 'ДЕЯТЕЛЬНОСТЬ ПРОФЕССИОНАЛЬНАЯ, НАУЧНАЯ И ТЕХНИЧЕСКАЯ ',
            li: [
              `МУ «Межотраслевая централизованная бухгалтерия» (Республика Коми)`,
              `МКУ МО «Город Архангельск» «Центр бухгалтерского и экономического обслуживания» (Архангельская область)`,
              `ОГУ «Дирекция по финансированию и материально-техническому обслуживанию учреждений в сфере здравоохранения» (ЯНАО)`,
            ],
          }
        ],
        qualities: [
          {
            id: 1,
            body: `Знание и применение в профессиональной деятельности законодательства, относящегося к Арктической зоне Российской Федерации (напр., Федеральный закон от 13.07.2020 N 193-ФЗ «О государственной поддержке предпринимательской деятельности в Арктической зоне Российской Федерации»)`,
          },{
            id: 2,
            body: `Знание и применение в профессиональной деятельности законодательства, относящегося к районам Крайнего Севера и местностей, приравненных к районам Крайнего Севера`,
          },{
            id: 3,
            body: `Знание и применение в профессиональной деятельности регионального законодательства субъектов АЗ РФ`,
          },{
            id: 4,
            body: `Знание специфики экономики и организации производства и управления при реализации инвестиционных проектов в АЗ РФ`,
          },{
            id: 5,
            body: `Ведение бухгалтерского учета`,
          },{
            id: 6,
            body: `Составление и представление бухгалтерской, консолидированной отчетности `,
          }
        ],
      },{
        id: 1,
        text: 'Водитель автомобиля',
        branches: [
          {
            id: 1,
            title: 'ТРАНСПОРТИРОВКА И ХРАНЕНИЕ',
            li: [
              `ООО «РН-Транспорт» (ЯНАО)`,
              `ООО «Усинское территориальное транспортное управление» (Республика Коми)`,
              `ООО «Газпром трансгаз Сургут» (ЯНАО)`,
            ],
          },{
            id: 2,
            title: 'ОБРАБАТЫВАЮЩИЕ ПРОИЗВОДСТВО',
            li: [
              `Заполярный филиал ПАО ГМК «Норильский никель» (Красноярский край)`,
            ],
          },{
            id: 3,
            title: 'ДОБЫЧА ПОЛЕЗНЫХ ИСКОПАЕМЫХ',
            li: [
              `ООО «Газпром добыча Ямбург» (ЯНАО)`,
              `ООО «Газпром добыча Уренгой» (ЯНАО)`,
              `АО «Карельский окатыш» (Республика Карелия)`,
              `АО «Ковдорский ГОК» (Мурманская область)`,
            ],
          }
        ],
        qualities: [
          {
            id: 1,
            body: `Знание модели оптимального поведения водителя в дорожном движении при обледенении дорог`,
          },{
            id: 2,
            body: `Владение навыками самостоятельного ремонта автомобиля, в том числе в отдалении от населенных пунктов и станций СТО, а также при сложных погодных условиях`,
          },{
            id: 3,
            body: `Владение знаниями и навыками выживания в экстремальных условиях Арктики`,
          },{
            id: 4,
            body: `Умение управлять автомобильным транспортным средством (АТС) в различных условиях движения (в том числе, в условиях полярной ночи, по зимникам, в условиях гололеда, снежных заносов, метели)`,
          },{
            id: 5,
            body: `Умение пускать двигатель при различном его температурном состоянии (в том числе при экстремально низких температурах)`,
          },{
            id: 6,
            body: `Владение приемами обеспечения надежного закрепления груза с учетом изменения свойств крепежных материалов при экстремально низких температурах и значительной ветровой нагрузке `,
          },{
            id: 7,
            body: `Умение регулировать движение АТС при возникновении нештатных ситуаций, вызванных экстремальными погодными условиями`,
          }
        ],
    
      },{
        id: 2,
        text: 'Повар',
        branches: [
          {
            id: 1,
            title: 'ДЕЯТЕЛЬНОСТЬ ГОСТИНИЦ И ПРЕДПРИЯТИЙ ОБЩЕСТВЕННОГО ПИТАНИЯ ',
            li: [
              `ООО «ПНГ-ОРС» (ЯНАО)`,
              `ООО «Пуровская компания общественного питания и торговли - Пурнефтегазгеология» (ЯНАО)`,
              `ООО «ЭКОПОЛИС» (ЯНАО)`,
            ],
          },{
            id: 2,
            title: 'ТРАНСПОРТИРОВКА И ХРАНЕНИЕ ',
            li: [
              `ФГУП «Атомфлот» (Мурманская область)`,
            ],
          }
        ],
        qualities: [
          {
            id: 1,
            body: `Владение навыками по разработке системы рационального и сбалансированного питания, в том числе обеспечения необходимыми витаминами и микроэлементами в достаточном количестве с учетом повышенной нагрузки организма в условиях Арктики`,
          },{
            id: 2,
            body: `Знание требований к качеству, срокам и условиям хранения, признакам и органолептическим методам определения доброкачественности пищевых продуктов, используемых в приготовлении блюд, напитков и кулинарных изделий`,
          },{
            id: 3,
            body: `Знание инструкций по подготовке инвентаря, оборудования и организации рабочего места повара к работе`,
          },{
            id: 4,
            body: `Владение навыками организации и координации, контроля и оценки эффективности процессов основного производства организации питания`,
          },{
            id: 5,
            body: `Знание региональной специфики приготовления блюд`,
          },{
            id: 6,
            body: `Соблюдение стандартов и соблюдение санитарно-гигиенических норм на кухне, складе и в обеденном зале`,
          }
        ],
      },{
        id: 8,
        text: 'Слесарь-ремонтник',
        branches: [
          {
            id: 1,
            title: 'ДОБЫЧА ПОЛЕЗНЫХ ИСКОПАЕМЫХ ',
            li: [
              `ООО «РН-Пурнефтегаз» (ЯНАО)`,
              `ООО «Газпром добыча Уренгой» (ЯНАО)`,
              `Газпромнефть Муравленко (ЯНАО)`,
            ],
          },{
            id: 2,
            title: 'ОБРАБАТЫВАЮЩИЕ ПРОИЗВОДСТВА ',
            li: [
              `ООО «Норильскникельремонт» (Красноярский край)`,
              `АО «ПО «Севмаш» (Архангельская область)`,
              `Акционерное общество «Архангельский целлюлозно-бумажный комбинат» (Архангельская область)`,
            ],
          },{
            id: 3,
            title: 'ОБЕСПЕЧЕНИЕ ЭЛЕКТРИЧЕСКОЙ ЭНЕРГИЕЙ, ГАЗОМ И ПАРОМ, КОНДИЦИОНИРОВАНИЕ ВОЗДУХА ',
            li: [
              `ОАО «Тепло-Энергетик» (ЯНАО)`,
              `Уренгойский филиал ООО «Газпром энерго» (ЯНАО)`,
            ],
          }
        ],
        qualities: [
          {
            id: 1,
            body: `Владение навыками по обслуживанию и ремонту деталей, узлов и механизмов в сложных условиях (экстремально низкие температуры, резкие перепады температур, обледенение)`,
          },{
            id: 2,
            body: `Знание основных механических свойств обрабатываемых материалов, в том числе при низких температурах`,
          },{
            id: 3,
            body: `Владение навыками технического обслуживание механизмов, оборудования, агрегатов и машин с учетом повышенного износа в условиях экстремально низких температур, резких перепадов температур, обледенения`,
          },{
            id: 4,
            body: `Владение знаниями и навыками выживания в экстремальных условиях Арктики`,
          },{
            id: 5,
            body: `Умение производить монтаж и демонтаж узлов и механизмов, оборудования, агрегатов и машин`,
          },{
            id: 6,
            body: `Умение осуществлять слесарную и механическую обработку деталей`,
          },{
            id: 7,
            body: `Умение проводить испытания особо сложного оборудования, агрегатов и машин`,
          }
        ],
      },{
        id: 9,
        text: 'Электрогазосварщик',
        branches: [
          {
            id: 1,
            title: 'ДОБЫЧА ПОЛЕЗНЫХ ИСКОПАЕМЫХ ',
            li: [
              `АО «Ковдорский ГОК» (Мурманская область)`,
              `ООО «Газпром добыча Уренгой» (ЯНАО)`,
              `АО «Карельский окатыш» (Республика Карелия)`,
            ],
          },{
            id: 2,
            title: 'ОБРАБАТЫВАЮЩИЕ ПРОИЗВОДСТВА ',
            li: [
              `ООО «Норильскникельремонт» (Красноярский край)`,
              `АО «Центр судоремонта «Звёздочка» (Архангельская область)`,
            ],
          },{
            id: 3,
            title: 'СТРОИТЕЛЬСТВО',
            li: [
              `ООО «Заполярная строительная компания» (Красноярский край)`,
              `ООО «Печенгское Строительное Объединение» (Мурманская область)`,
            ],
          }
        ],
        qualities: [
          {
            id: 1,
            body: `Изготовление, реконструкция, монтаж, ремонт и строительство конструкций различного назначения с применением ручной и частично механизированной сварки в условиях низких температур`,
          },{
            id: 2,
            body: `Проведение в Арктическом регионе работ разной сложности и различными технологиями в зависимости от наличия сертификата по трудовой функции, уровня и подуровня квалификации в соответствии с ЕТКС`,
          },{
            id: 3,
            body: `Проведение подводной сварки и резки металлов при низких температурах и в условиях наличия ледяного покрова на поверхности водоема`,
          },{
            id: 4,
            body: `Выполнение работы в условиях Арктического региона и сурового климата строго в соответствии с технологическими свойствами свариваемых металлов, включая высоколегированные стали, а также наплавленного металла и металла, подвергающегося строганию`,
          },{
            id: 5,
            body: `Сварка (наплавка, резка) сложных и ответственных конструкций (оборудования, изделий, узлов, трубопроводов, деталей) из различных материалов (сталей, чугуна, цветных металлов и сплавов, полимерных материалов)`,
          },{
            id: 6,
            body: `Применение правил безопасной эксплуатации баллонов, мер пожарной безопасности, прохождение противопожарного инструктажа и пожарно-технического минимума по соответствующей программе, соблюдение охраны труда и требований охраны труда в установленном порядке`,
          }
        ],
      },{
        id: 10,
        text: 'Электромонтер по ремонту и обслуживанию электрооборудования',
        branches: [
          {
            id: 1,
            title: 'ОБЕСПЕЧЕНИЕ ЭЛЕКТРИЧЕСКОЙ ЭНЕРГИЕЙ, ГАЗОМ И ПАРОМ, КОНДИЦИОНИРОВАНИЕ ВОЗДУХА ',
            li: [
              `ООО «Ноябрьскэнергонефть» (ЯНАО)`,
              `АО «Мурманэнергосбыт» (Мурманская область)`,
              `ООО «НОВАТЭК-Энерго» (ЯНАО)`,
            ],
          },{
            id: 2,
            title: 'ДОБЫЧА ПОЛЕЗНЫХ ИСКОПАЕМЫХ ',
            li: [
              `ООО «РН-Пурнефтегаз» (ЯНАО)`,
              `ООО «Газпром добыча Надым» (ЯНАО)`,
              `ООО «Газпром добыча Ямбург» (ЯНАО)`,
            ],
          },{
            id: 3,
            title: 'ОБРАБАТЫВАЮЩИЕ ПРОИЗВОДСТВА ',
            li: [
              `АО «Кольская ГМК» (Мурманская область)`,
              `АО «ПО «Севмаш» (Архангельская область)`,
              `ООО «Норильскникельремонт» (Красноярский край)`,
            ],
          }
        ],
        qualities: [
          {
            id: 1,
            body: `Участие в ремонте, осмотрах и техническом обслуживании электрооборудования с выполнением работ по разборке, сборке, наладке и обслуживанию электрических приборов, электромагнитных, магнитоэлектрических и электродинамических систем в условиях экстремально низких температур, обледенения, снеговой и ветровой нагрузки, резко изменяющегося температурного режима`,
          },{
            id: 2,
            body: `Прокладка кабельных трасс в условиях многолетней мерзлоты`,
          },{
            id: 3,
            body: `Регулирование нагрузки электрооборудования, установленного на обслуживаемом участке`,
          },{
            id: 4,
            body: `Обслуживание и ремонт солнечных и ветровых энергоустановок мощностью до 50 кВт, в т.ч. в условиях экстремально низких температур, обледенения, снеговой и ветровой нагрузки, резко изменяющегося температурного режима`,
          },{
            id: 5,
            body: `Выполнение слесарных, монтажных и плотничных работ при ремонте электрооборудования с учетом особенностей климата территорий АЗ РФ`,
          },{
            id: 6,
            body: `Выполнение работ на электростанциях, трансформаторных электроподстанциях`,
          },{
            id: 7,
            body: `Выявление и устранение отказов, неисправностей и повреждений электрооборудования в условиях Арктического региона`,
          }
        ],
      }
    ],
    
  }

